import Pagination from "../../components/pagination";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import F from "../../Functions";
import axios from "axios";
import { Row, Col, Card, Icon, Input, Table, Button } from "antd";
import { Translate } from "react-translated";
import { debounceQuery } from "../../utils/Constants";
import CustomAgGridTable from '../../Common-Table/CustomAgGridTable';
import '../../Common-Table/CustomAgGridTable.css';
import CustomHeader from '../../CommonHeader/CustomHeader';

class SearchStaff extends Component {
  state = {
    loading: true,
    staff_list: [],
    all_staff_list: [],
    page: 1,
    total_pages: 0,
    search: "",
  };

  componentDidMount = () => {
    // default load staffs with 1st page
    this.loadStaffs(1);
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.location.state !== this.props.location.state) {
      this.loadStaffs(1);
    }
  };

  loadStaffs = (page) => {
    let search = "";

    const searchPurify = F.removeSpecialCharactersFromString(this.state.search);

    if (searchPurify.trim().length > 0) {
      search = searchPurify;
    }
    const api =
      "/api/get_all_staff_agency_from_admin?page=" +
      page +
      "&search=" +
      search +
      "";
    this.setState({ loading: true });
    axios.get(api).then((res) => {
      this.setState({
        loading: false,
        staff_list: res.data.objects,
        page: res.data.page,
        total_pages: res.data.total_pages,
        all_staff_list: res.data.objects,
      });
    });
  };

  // sort = () => {
  //   if (this.state.staff_list.length) {
  //     let sortedStaffs = this.state.staff_list.sort((a, b) =>
  //       a.first_name > b.first_name ? 1 : -1
  //     );
  //     this.setState({ staff_list: sortedStaffs });
  //   }
  // };

  searchStaff = (event) => {
    this.setState({ search: event.target.value }, () => {
      debounceQuery(this.loadStaffs.bind(this, 1));
    });
  };


  onGridReady = (params) => {
    this.setState({
      gridApi: params.api,
      columnApi: params.columnApi
    });

    const savedState = localStorage.getItem("agGridColumnState");
    if (savedState) {
      params.columnApi.applyColumnState({
        state: JSON.parse(savedState),
        applyOrder: true,
      });
    }
  }

  saveState = (params) => {
    const state = params.columnApi.getColumnState();
    localStorage.setItem("agGridColumnState", JSON.stringify(state));
  }


  refreshInfo = () => {
    localStorage.removeItem("agGridColumnState");

    if (this.state.columnApi) {
      this.state.columnApi.resetColumnState();
      this.state.columnApi.resetColumnGroupState();
    }

    this.setState({ search: "" }, () => {
      this.loadStaffs(this.state.page);
    });
  };

  render() {
    const { loading, staff_list, page, total_pages } = this.state;

    // new columns
    const columnDefs = [
      {
        headerClass: 'custom-ag-header',
        headerName: 'First Name',
        field: 'first_name',
        minWidth: 250,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['First Name'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'first_name',
        }),
        cellRendererFramework: (params) => (
          <div className="autoHandleContentStyle" style={{ width: 250 }}>
            {params.data.first_name}
          </div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: 'Last Name',
        field: 'last_name',
        minWidth: 250,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Last Name'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'last_name',
        }),
        cellRendererFramework: (params) => (
          <div className="autoHandleContentStyle" style={{ width: 250 }}>
            {params.data.last_name}
          </div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: 'Phone',
        field: 'phone',
        minWidth: 250,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Phone'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'phone',
        }),
        cellRendererFramework: (params) => (
          <a href={"tel:" + F.phone_format(params.data.phone)}>
            {F.phone_format(params.data.phone)}
          </a>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: 'Agency',
        field: 'agency_name',
        minWidth: 300,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Agency'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'agency_name',
        }),
        cellRendererFramework: (params) => (
          <Link to={"/super-admin/agency/" + params.data.agency_id}>
            {params.data.agency_name}
          </Link>
        ),
      },
    ];

    return (
      <div>
        <Card
          type="inner"
          title={
            <div style={{ paddingTop: 7 }}>
              <Icon type="team" style={{ marginRight: 10, color: "#1890ff" }} />
              Search Staff
              {/* <span
                style={{ marginLeft: 10, cursor: "pointer", fontSize: "20px" }}
                onClick={() => this.sort()}
              >
                ↑
              </span> */}
            </div>
          }
          className="tableCard"
          loading={loading}
          extra={
            <div>
              <Row gutter={16}>
                <Col md={50} span={16}>
                  <Input
                    placeholder="Search Staff"
                    className="borderRadius-28"
                    onChange={(e) => this.searchStaff(e)}
                    style={{ width: "100%" }}
                    value={this.state.search}
                    onPressEnter={() => {
                      this.loadStaffs(1);
                    }}
                  />
                  {this.state.search ? (
                    <Icon
                      type="close"
                      onClick={() => this.searchStaff({ target: { value: "" } })}
                      className="icon-style"
                    />
                  ) : (
                    <Icon
                      type="search"
                      className="icon-style"
                    />
                  )}
                </Col>
                <Col md={50} span={8}>
                  <Button
                    type="primary"
                    className="bg-164897 borderRadius-28"
                    onClick={this.refreshInfo}
                  >
                    <Icon type="reload" />
                    Refresh
                  </Button>
                </Col>
              </Row>
            </div>
          }
        >
          <CustomAgGridTable
            onGridReady={this.onGridReady}
            onColumnMoved={this.saveState}
            onSortChanged={this.saveState}
            onFilterChanged={this.saveState}
            rowDatas={staff_list}
            columnDefss={columnDefs}
          />
          <Pagination
            className="pagination-container cpagination"
            current_page={page}
            total_pages={total_pages}
            onClick={(page) => {
              this.loadStaffs(page);
            }}
          />
        </Card>
      </div>
    );
  }
}

export default SearchStaff;



// WEBPACK FOOTER //
// ./src/scenes/SuperAdmin/search-staff.js